import React, { useState } from 'react';
import LeaveRequestViewModal from './LeaveRequestViewModal';
import './DayLeaveDetailsModal.css';

const DayLeaveDetailsModal = ({ 
  date, 
  leaveRequests = [], 
  onClose, 
  isTeamView = false 
}) => {
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateShort = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDays = (days) => {
    const num = parseFloat(days);
    return num % 1 === 0 ? Math.floor(num) : num.toFixed(1);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'pending': return 'status-pending';
      case 'approved': return 'status-approved';
      case 'rejected': return 'status-rejected';
      case 'cancelled': return 'status-cancelled';
      case 'completed': return 'status-completed';
      default: return 'status-pending';
    }
  };

  const handleLeaveClick = (requestId) => {
    setSelectedRequestId(requestId);
    setShowDetailModal(true);
  };

  const handleDetailModalClose = () => {
    setShowDetailModal(false);
    setSelectedRequestId(null);
  };

  if (showDetailModal && selectedRequestId) {
    return (
      <LeaveRequestViewModal
        requestId={selectedRequestId}
        onClose={handleDetailModalClose}
        isAdmin={false}
        isTeamView={isTeamView}
      />
    );
  }

  return (
    <div className="modal-overlay day-leave-modal-overlay">
      <div className="day-leave-modal">
        <div className="day-leave-modal-header">
          <div className="header-content">
            <h3>Leave on {formatDate(date)}</h3>
            <div className="leave-count">
              {leaveRequests.length} {leaveRequests.length === 1 ? 'Leave Request' : 'Leave Requests'}
            </div>
          </div>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="day-leave-modal-body">
          {leaveRequests.length === 0 ? (
            <div className="no-leave-message">
              <p>No leave requests for this date.</p>
            </div>
          ) : (
            <div className="leave-requests-list">
              {leaveRequests.map((request) => (
                <div 
                  key={request.id} 
                  className="leave-request-card"
                  onClick={() => handleLeaveClick(request.id)}
                >
                  <div className="leave-card-header">
                    <div className="leave-type-section">
                      <div 
                        className="leave-type-indicator" 
                        style={{ backgroundColor: request.leave_type_details?.color || '#4CAF50' }}
                      ></div>
                      <div className="leave-type-info">
                        <div className="leave-type-name">
                          {request.leave_type_details?.name || 'Absent'}
                        </div>
                        {isTeamView && request.employee_name && (
                          <div className="employee-name-badge">
                            {request.employee_name}
                          </div>
                        )}
                      </div>
                    </div>
                    <span className={`status-badge-compact ${getStatusBadgeClass(request.status)}`}>
                      {request.status?.charAt(0).toUpperCase() + request.status?.slice(1)}
                    </span>
                  </div>
                  
                  <div className="leave-card-details">
                    <div className="detail-row">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <span className="detail-text">
                        {formatDateShort(request.start_date)} - {formatDateShort(request.end_date)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <span className="detail-text">
                        {formatDays(request.total_days)} {parseFloat(request.total_days) === 1 ? 'day' : 'days'}
                      </span>
                    </div>
                    {request.reason && (
                      <div className="leave-reason-preview">
                        {request.reason.length > 100 
                          ? `${request.reason.substring(0, 100)}...` 
                          : request.reason
                        }
                      </div>
                    )}
                  </div>
                  
                  <div className="leave-card-footer">
                    <span className="view-details-link">
                      View Full Details
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayLeaveDetailsModal;


